import { render, staticRenderFns } from "./normal.md?vue&type=template&id=79801287&"
import script from "./normal.md?vue&type=script&lang=js&"
export * from "./normal.md?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports